import nanobus from "../nanobus";

/**
 * Singleton event bus
 */
export default nanobus();
